import request from '../../helper/request';

export function getDrivers(params) {
  return request('/drivers', {
    method: 'GET',
    params: params,
  });
}

export function getDriver(id) {
  return request('/drivers/' + id, {
    method: 'GET',
  });
}

export function createDriver(params) {
  return request('/drivers', {
    method: 'POST',
    data: params,
  });
}

export function updateDriver(params, id) {
  return request('/drivers/' + id, {
    method: 'PATCH',
    data: params,
  });
}

export function approveDriver(id, email) {
  return request('/drivers/' + id + '/approve', {
    method: 'PATCH',
    data: email || {},
  });
}

export function rejectDriver(id, email) {
  return request('/drivers/' + id + '/reject', {
    method: 'PATCH',
    data: email || {},
  });
}

export function lockDriver(id) {
  return request('/drivers/' + id + '/lock', {
    method: 'PATCH',
  });
}

export function getEmailTemplates() {
  return request('/email-templates', {
    method: 'GET',
  });
}

export function updateEmailTemplate(key, data) {
  return request('/email-templates/' + key, {
    method: 'PUT',
    data,
  });
}

export function broadcastDriversNotification(params) {
  return request('/notifications/broadcast/drivers', {
    method: 'POST',
    data: params,
  });
}

export function checkMissingDriverIds() {
  return request('/drivers/meta/has-missing-driver-ids', {
    method: 'GET',
  });
}

export function seedDriverIds() {
  return request('/drivers/meta/seed-driver-ids', {
    method: 'POST',
  });
}
//   return request('/drivers/' + id, {
//     method: 'DELETE',
//   });
// }
